import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BRAND = "Bad Ass Horse Sales";
const ROUTES = [
  [/^\/login/, "Seller Portal"],
  [/^\/auth\/verify/, "Signing In"],
  [/^\/apply\//, "Horse Application"],
  [/^\/invite\//, "Pre-Approved Invitation"],
  [/^\/privacy-policy/, "Privacy Policy"],
  [/^\/dashboard\/applications\//, "My Application"],
  [/^\/dashboard/, "Seller Dashboard"],
  [/^\/listing\//, "Edit Listing"],
  [/^\/applications\/[^/]+/, "Application Details"],
  [/^\/applications/, "Applications"],
  [/^\/horses/, "Horse Ads"],
  [/^\/horse\//, "Ad Builder"],
  [/^\/review/, "Review Queue"],
  [/^\/pipeline/, "Pipeline"],
  [/^\/contacts/, "Contacts"],
  [/^\/seller-preview/, "Preview as Seller"],
  [/^\/style-library/, "Ad Style Library"],
  [/^\/settings/, "Settings"],
];

export const setPageTitle = (t) => { const brand = window.__brandName || ""; document.title = t ? (brand ? `${t} | ${brand}` : t) : brand || BRAND; };

export function TitleSync() {
  const { pathname } = useLocation();
  useEffect(() => {
    setPageTitle(ROUTES.find(([re]) => re.test(pathname))?.[1]);
  }, [pathname]);
  return null;
}
